import * as Yup from 'yup'

const TIPO_INFORME_MEDICO = 299001;

export const validationSchemasSolicitarInformeProfesional = () => {
  let validationObject = {};

  validationObject["observacionesAnalistaCIA"] = Yup.string().required('Este campo es obligatorio');

  //validationObject["gestor"] = Yup.string().required('Este campo es obligatorio');

  validationObject["gestor"] = Yup.string().test(
    'valida-segun-accion-btn',
    'Este campo es obligatorio',
    function (value) {
      const parent = this.parent || {};
      const accionBtn = parent.accionBtn;
  
      if (accionBtn === 'autorizar') {
        return !!value;
      }
      return true; 
    }
  )

  return Yup.object().shape(validationObject);
}